module.exports = __webpack_public_path__ + "static/media/7.02ae3f9f.jpg";